import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

const OpticksPillPlanMax = ({
  className,
  size,
  width,
  height,
  viewBox = "0 0 53 22",
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`plan-pill plan-pill-max${className ? ` ${className}` : ""}`}
    size={size}
    width={width}
    height={height}
    viewBox={viewBox}
    aria-label={ariaLabel}
  >
    <rect
      width="53"
      height="22"
      rx="11"
      fill="var(--color-plan-max)"
      id="opticks-pill-fill"
    />
    <path
      d="M10.9758 15.5V5.7H13.5798L16.2678 10.992L18.9558 5.7H21.5598V15.5H19.6418V8.29L16.2398 14.8L12.8518 8.262V15.5H10.9758ZM22.3835 15.5L26.4155 5.7H28.7535L32.7435 15.5H30.5455L29.5515 12.924H25.5055L24.4975 15.5H22.3835ZM26.1355 11.3H28.9355L27.5355 7.688L26.1355 11.3ZM33.0615 15.5L36.7995 10.432L33.2575 5.7H35.6795L38.0035 8.92L40.3135 5.7H42.6515L39.1655 10.432L42.9455 15.5H40.5235L37.9615 11.944L35.3995 15.5H33.0615Z"
      fill="white"
      id="opticks-pill-fill"
    />
  </OpticksSvgElement>
);

export default OpticksPillPlanMax;
